import { useQuery } from '@tanstack/react-query';
import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { ApiClient } from '@/api/client';
import { MainLayer } from '@/effects/layers';
import { runEffect } from '@/effects/runtime';
import { QUERY_KEYS } from '@/lib/constants';
import { FundingPoolsResponseSchema } from '@/api/schemas/funding-pool.schema';

export function useFundingPools(groupId: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.FUNDING_POOLS, groupId],
    queryFn: async () => {
      const program = pipe(
        Effect.gen(function* () {
          const apiClient = yield* ApiClient;
          const response = yield* apiClient.get(
            `/groups/${groupId}/pools`,
            FundingPoolsResponseSchema
          );
          return response.pools;
        }),
        Effect.provide(MainLayer)
      );

      return runEffect(program);
    },
    enabled: !!groupId,
    staleTime: 60_000,
  });
}

